'use strict';

export default function routes($stateProvider) {
	'ngInject';

	$stateProvider
	.state('borne_admin', {
		url: '/borne/admin',
		template: require('./admin/admin.html'),
		controller: 'AdminController',
		controllerAs: 'vm'
	})
	.state('borne_main', {
		url: '/borne/:id',
		template: require('./main/main.html'),
		controller: 'MainController',
		controllerAs: 'vm'
	})
	.state('borne_categories', {
		url: '/borne_categories/:id',
		template: require('./categories/categories.html'),
		controller: 'CategoriesController',
		controllerAs: 'vm'
	})
	.state('borne_langues', {
		url: '/borne_langues/:id',
		template: require('./langues/langues.html'),
		controller: 'LanguesController',
		controllerAs: 'vm'
	})
	.state('borne_collecte', {
		url: '/borne_collecte/:id/:borneId',
		template: require('./collecte/collecte.html'),
		controller: 'CollecteController',
		controllerAs: 'vm'
	})
	.state('borne_formation', {
		url: '/borne_formation/:id/:borneId',
		template: require('./formation/formation.html'),
		controller: 'FormationController',
		controllerAs: 'vm'
	})
	.state('borne_questions', {
		url: '/borne_questions/:id/:borneId',
		template: require('./questions/questions.html'),
		controller: 'QuestionsController',
		controllerAs: 'vm'
	})
	.state('borne_badge', {
		url: '/borne_badge/:id/:borneId',
		template: require('./badge/badge.html'),
		controller: 'BadgeController',
		controllerAs: 'vm'
	})
}


// WEBPACK FOOTER //
// ./client/app/borne/borne.routes.js